<template>
  <header class="ui-header">
    <div class="ui-header__brand">
      <router-link :to="{ name: 'UserDashboard' }">
        <svg
          class="ui-header__logo"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 249.056 63.266"
        >
          <path
            d="M109.531 24.721c0-1.127-.596-1.65-1.646-1.65h-2.994v-8.09h8.76c3.372 0 5.02 1.574 5.02 4.272v1.12c0 .828-.148 1.65-.148 1.65h.149c1.643-3.224 5.765-7.94 13.479-7.94 8.467 0 13.333 4.42 13.333 14.529v14.909c0 1.05.602 1.646 1.651 1.646h2.995v8.015h-9.064c-3.592 0-5.09-1.497-5.09-5.093V30.563c0-4.646-1.2-7.792-5.994-7.792-5.094 0-8.914 3.221-10.263 7.792-.526 1.572-.75 3.296-.75 5.093v17.526h-9.438v-28.46M162.594 0h8.237v8.768h-8.237zm-.454 24.721c0-1.127-.598-1.65-1.648-1.65h-2.997v-8.09h9.065c3.518 0 5.018 1.574 5.018 5.097v23.443c0 1.05.601 1.646 1.649 1.646h2.995v8.015h-9.063c-3.521 0-5.019-1.497-5.019-5.093V24.72M188.536 22.547h-4.942v-7.565h5.174V4.57h9.284v10.412h8.684v7.565h-8.684v15.427c0 6.297 4.943 7.193 7.566 7.193 1.046 0 1.721-.151 1.721-.151v8.315s-1.196.226-2.917.226c-5.32 0-15.886-1.573-15.886-14.383V22.547M221.43 55.496c2.31 0 4.363-1.388 5.55-4.297l1.123-2.576-11.232-25.312c-.398-.992-.86-1.192-1.788-1.192h-.99v-7.137h5.551c2.379 0 3.568.86 4.428 3.173l6.608 16.852c.66 1.72 1.191 4.494 1.191 4.494h.13s.531-2.773 1.124-4.494l5.75-16.852c.796-2.314 2.184-3.173 4.494-3.173h5.687v7.137h-.996c-.987 0-1.52.2-1.914 1.192l-12.095 30.466c-2.378 6.08-7.139 8.79-12.16 8.79-5.287 0-8.53-3.438-8.53-3.438l3.243-5.947s2.047 2.314 4.826 2.314M78.781 14.083c-4.583 0-8.794 1.313-12.226 3.602a24.164 24.164 0 014.466 7.617 11.09 11.09 0 017.76-3.13c6.216 0 11.39 4.87 11.39 11.909 0 7.117-5.174 11.911-11.39 11.911-6.11 0-11.255-4.742-11.31-11.797a.85.85 0 00.008-.114c0-11.685-9.289-19.998-20.974-19.998-11.612 0-20.896 8.313-20.896 19.998 0 7.778 4.063 14.015 10.172 17.349l-1.479 11.836 11.649-9.19c.184.002.37.005.554.005 4.62 0 8.857-1.305 12.302-3.594a24.06 24.06 0 01-4.463-7.615c-2.055 1.98-4.818 3.12-7.839 3.12-6.143 0-11.31-4.794-11.31-11.911 0-7.04 5.167-11.91 11.31-11.91 6.164 0 11.305 4.795 11.386 11.743-.003.055-.006.11-.006.167 0 11.763 9.287 20 20.896 20 11.688 0 20.98-8.237 20.98-20 0-11.685-9.292-19.998-20.98-19.998M21.727 44.661c-2.623 0-7.566-.895-7.566-7.192V5.096C14.161 1.576 12.583 0 9.065 0H0v8.091h2.995c1.05 0 1.65.526 1.65 1.646v28.932c0 12.81 10.566 14.383 15.886 14.383 1.722 0 2.917-.227 2.917-.227V44.51s-.675.151-1.721.151"
          />
        </svg>
      </router-link>
    </div>

    <div class="ui-header__nav">
      <!--<UiHeaderUserLang />-->
      <a class="btn" href="https://doc.loonity.com" target="_blank">
        <font-awesome-icon icon="life-ring" />
      </a>
      <UiHeaderUserSettings />
    </div>
  </header>
</template>

<script>
import UiHeaderUserSettings from "./UiHeaderUserSettings";
import UiHeaderUserLang from "./UiHeaderUserLang";

export default {
  name: "UiHeader",
  components: {
    UiHeaderUserSettings,
    UiHeaderUserLang,
  },
};
</script>
